// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_f9-1";
export var quotedThread = "_f9-0";